import { format } from 'date-fns';
import { useFilters } from '../../../contexts/filters/FiltersContext';
import { downloadBlobAsFile, getDefaultRange } from '../../../utils/utils';
import { exportPromptStats } from '../../../services/monitor/keywords/stats/KeywordsStatsService';
import { exportMonitorSources } from '../../../services/monitor/prompt/PromptService';
import { exportMonitorData } from '../../../api/services/monitor/data/MonitorDataService';
import { getMonitorTypeByChatOptionsType } from '../../../helpers/StatsHelpers';

const useExportPromptData = (promptId: number) => {
  const { range, selectedChatType, domain } = useFilters();

  const exportStats = async () => {
    const defaultRange = getDefaultRange();
    const startDate = range && range[0] ? range[0] : defaultRange[0];
    const endDate = range && range[1] ? range[1] : defaultRange[1];

    const blob = await exportPromptStats(promptId, selectedChatType || 'ALL', startDate, endDate);
    downloadBlobAsFile(
      blob,
      `Question-${promptId}-${format(startDate, 'yyyyMMdd')}-${format(endDate, 'yyyyMMdd')}.csv`
    );
  };

  const exportSources = async () => {
    const defaultRange = getDefaultRange();
    const startDate = range && range[0] ? range[0] : defaultRange[0];
    const endDate = range && range[1] ? range[1] : defaultRange[1];

    const blob = await exportMonitorSources(
      promptId,
      selectedChatType || 'ALL',
      domain || 'ALL',
      startDate,
      endDate
    );
    downloadBlobAsFile(
      blob,
      `Sources-${promptId}-${format(startDate, 'yyyyMMdd')}-${format(endDate, 'yyyyMMdd')}.csv`
    );
  };

  const exportAiAnswers = async (keyword: string) => {
    if (!keyword) {
      return;
    }
    const defaultRange = getDefaultRange();
    const startDate = range && range[0] ? range[0] : defaultRange[0];
    const endDate = range && range[1] ? range[1] : defaultRange[1];

    const period = 'DAILY';
    const monitorType = getMonitorTypeByChatOptionsType(selectedChatType || 'ALL');

    const blob = await exportMonitorData(promptId, period, monitorType, startDate, endDate, keyword);
    downloadBlobAsFile(
      blob,
      `Answers-${promptId}-${format(startDate, 'yyyyMMdd')}-${format(endDate, 'yyyyMMdd')}.csv`
    );
  };

  return { exportStats, exportSources, exportAiAnswers };
};

export default useExportPromptData;
